import { render } from "./carruselComponent_ingles.vue?vue&type=template&id=6df3aecd&scoped=true"
import script from "./carruselComponent_ingles.vue?vue&type=script&lang=js"
export * from "./carruselComponent_ingles.vue?vue&type=script&lang=js"

import "./carruselComponent_ingles.vue?vue&type=style&index=0&id=6df3aecd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df3aecd"]])

export default __exports__